export default {
  common: {
    login: "登录",
    userName: "用户名",
    password: "密码",
    rememberPassword: "记住账号密码",
    modifyPassword: "修改密码",
    accountRegister: "账号注册",
    pleaseInput: "请输入",
    loginErrorCheckNamePassword: "登录失败，请检查用户名和密码",
    guest: "访客",
    superAdmin: "超级管理员",
    logOut: "登出",
    inputUserName: "请输入用户名",
    inputPassword: "请输入密码",

    modifySuccessfully: "修改密码成功!",

    using: "使用",
    toLogin: "来进行登录",
    noOktaLoginUrl: "没有找到 OKTA 的登录链接"
  },
  register: {
    email: "电子邮箱",
    confirmPassword: "确认密码",
    register: "注册",
    emailRequire: "请输入邮箱",
    passwordRequire: "请输入密码",
    confirmPasswordRequire: "请输入确认密码",
    passwordInconsistency: "密码不一致",
    registeredSuccessfully: "注册成功,",
    jumpToLoginPage: "系统将自动为您跳转到登录页面。",
    contactAdminActivate: "请在登录前，先联系管理员为您激活账号。"
  },
  my: {
    about: "关于",
    language: "语言"
  }
}



// WEBPACK FOOTER //
// ./src/locale/login/zh.js